<template>
  <div>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <span class="title_head">Search Company</span>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        placeholder="Enter Company Name"
                        v-model="search_cname"
                        name="company_name"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <button
                      type="button"
                      class="btn btn-pill btn-primary serach_bttn"
                      style="margin-top: 2px;"
                      @click.prevent="getcompany"
                    >
                      <i class="fa fa-search"></i> Search
                    </button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>

    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="title_head">
                Registered Company List
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div v-if="message.sucess != ''" class="alert alert-success">
                    <center>{{ message.sucess }}</center>
                  </div>
                </div>
              </div>
              <div class="table-responsive-sm">
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  mode="remote"
                  ref="my-table"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :pagination-options="{
                    enabled: true,
                    perPage: 10,
                  }"
                  styleClass="vgt-table striped bordered table-sm condensed"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'action'">
                      <i
                        class="fa fa-eye"
                        @click.prevent="viewvalue(props.row)"
                      ></i>
                      <i
                        class="fa fa-edit"
                        @click.prevent="editvalue(props.row)"
                      ></i>
                    </span>
                    <span v-else-if="props.column.field == 'userdtl'">
                      <i
                        class="fa fa-user-circle"
                        style="
                          color: #63c2de;
                          font-size: 18px;
                          cursor: pointer;
                        "
                        @click.prevent="userdetail(props.row)"
                      ></i>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      title="Company User Details "
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="warningModal"
      @ok="warningModal = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <vue-good-table
          :columns="columns1"
          :rows="rows1"
          mode="remote"
          ref="my-table1"
          :totalRows="totalRecords1"
          styleClass="vgt-table striped bordered table-sm condensed"
        >
        </vue-good-table>
      </b-collapse>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>
<script>
import Spinner from "../../spinner.vue";
export default {
  name: "CompanyManagement",
  components: { Spinner },
  data() {
    return {
      vfrst_time: false,
      loading: false,
      search_cname: "",
      totalRecords: 0,
      totalRecords1: 0,
      warningModal: false,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      columns: [
        {
          label: "Company Name",
          field: "company_name",
          width: "20% !important",
          thClass: "text-center",
        },
        {
          label: "Company ID",
          field: "company_id",
          width: "15% !important",
          thClass: "text-center",
        },
        {
          label: "Phone",
          field: "com_phone",
          width: "15% !important",
          thClass: "text-center",
        },
        {
          label: "Email",
          field: "cmp_email",
          width: "25% !important",
          thClass: "text-center",
        },
        {
          label: "Companies User",
          field: "userdtl",
          width: "15% !important",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Action",
          field: "action",
          width: "10% !important",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],

      rows: [],

      columns1: [
        {
          label: "Username",
          field: "username",
          width: "20% !important",
        },
        {
          label: "Role",
          field: "role",
          width: "10% !important",
        },
        {
          label: "Email",
          field: "email",
          width: "30% !important",
        },
        {
          label: "Phone",
          field: "phone",
          width: "20% !important",
        },
        {
          label: "Status",
          field: "status",
          width: "20% !important",
        },
      ],
      rows1: [],
      error: {
        errorname: false,
        errorided: "",
        errornameed: "",
        errorvalue: false,
      },
      message: {
        sucess: "",
        sucess1: "",
      },
    };
  },

  created() {
    this.getcompany();
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getcompany();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getcompany();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.getcompany();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.getcompany();
    },

    editvalue(data1) {
      this.$store.commit("set_reg_view", true);
      this.$store.commit("set_reg_rights", true);
      this.$router.push({
        name: "Company Registration",
        params: { company_id: data1.company_id },
      });
    },

    viewvalue(data) {
      this.$store.commit("set_reg_view", true);
      this.$store.commit("set_reg_rights", false);
      this.$router.push({
        name: "Company Registration",
        params: { company_id: data.company_id },
      });
    },

    userdetail(cmp) {
      // console.log('userdetail')
      // console.log(cmp)
      var _this = this;
      this.warningModal = true;
      this.loading = true;
      this.$http
        .get(
          "/api/users/getcompanyuserslist?filter[where][company_id]=" +
            cmp.company_id +
            "&filter[where][regcity]=" +
            cmp.regcity_code
        )
        .then(function (response) {
          // console.log(response)
          if (response.data.length > 0) {
            _this.rows1 = response.data;
          }
          _this.loading = false;
        })
        .catch(function (error) {
          _this.loading = false;
          // console.log(error)
        });
    },

    getcompany(val) {
      if (val === "comp") {
        if (this.vfrst_time === false) {
          this.vfrst_time = true;
        } else {
          return;
        }
      }
      this.loading = true;
      var _this = this;
      var filteParam = {};
      var data = "";
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var api = "";
      if (this.search_cname !== "") {
        api =
          "/api/companies?params=" +
          JSON.stringify(filteParam) +
          "&filter[where][company_name][ilike]=%" +
          this.search_cname +
          "%";
      } else {
        api = "/api/companies?params=" + JSON.stringify(filteParam);
      }
      // console.log(api)
      this.$http
        .get(api)
        .then(function (response) {
          // console.log(response)
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) {
            _this.rows = response.data;
          }
          _this.loading = false;
        })
        .catch(function (error) {
          _this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin_pages/company_mgmt.vue